import { isMobile } from '@/common/util'
import Router from '../router'
window.onresize = function () {
  const m = Router.history.current.path.split('/')[1]
  const isMPage = m === 'm' // 是否原来就在移动端页
  let isM = isMobile() // 是否移动端
  const html = document.getElementsByTagName('html')[0]
  if (!isM) {
    html.style.fontSize = 'initial'
  } else {
    var iW = document.documentElement.clientWidth
    var scale = iW / 375 * 20
    html.style.fontSize = scale + 'px' // 动态设置html根节点的font-size，用于rem布局；
  }
  if (isM && !isMPage) {
    Router.push({ path: '/m' })
  }
  if (!isM && isMPage) {
    Router.push({ path: '/' })
  }
}
